<template>
  <el-dialog
    width="400px"
    class="form-modal"
    :visible.sync="visible"
    :before-close="close"
    :close-on-click-modal="false"
    v-loading="faxProcessing"
  >
    <el-form>
      <h2 class="text-center black-text">
        FAX FROM: {{ userParams ? numberFormatter(userParams.fax_number) : "" }}
      </h2>

      <el-input type="text" v-model="faxTo" placeholder="Enter a number">
        <template slot="prefix">Number</template></el-input
      >

      <el-upload
        drag
        multiple
        action=""
        :auto-upload="false"
        :on-change="handleChange"
      >
        <i class="el-icon-upload"></i>
        <p>Drop files here to upload.</p>
      </el-upload>

      <div v-if="!!selectedFile" class="text-center">
        <button class="remove-btn" @click="selectedFile = null">
          Remove file
        </button>
      </div>

      <div class="text-center mt-30">
        <el-button type="primary" @click="submit">Send</el-button>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
import DadsSelect from "@/components/select";
import {phoneNumberFormatter} from "@/globals/globals";

export default {
  name: "VoxoMobileFaxForm",

  components: { DadsSelect },

  props: {
    visible: {
      required: true,
    },
    userParams: {
      required: true,
    },
    faxProcessing: {
      required: true,
    },
  },

  data() {
    return {
      faxTo: null,
      selectedFile: [],
    };
  },

  methods: {
    close() {
      this.clearFields();
      this.$emit("closeOperation");
    },

    submit() {
      const { fax_number, te_id, te_code, callerName, email } = this.userParams;

      const formData = new FormData();

      for(let i = 0; i < this.selectedFile.length; i++){
        formData.append(`file${i}`, this.selectedFile[i]);
      }

      formData.append("tenantId", te_id);
      formData.append("tenantCode", te_code);
      formData.append("faxTo", this.faxTo);
      formData.append("faxFrom", fax_number);
      formData.append("faxFromName", callerName);
      formData.append("statusEmail", email);

      this.$emit("faxOperation", formData);
    },

    clearFields() {
      this.faxTo = null;
      this.selectedFile = null;
    },

    handleChange(file) {
      this.selectedFile = [...this.selectedFile, file.raw];
    },

    numberFormatter(number) {
      return number
        ? phoneNumberFormatter(number)
        : number;
    },
  },
};
</script>

<style lang="scss" scoped>
.remove-btn {
  background: transparent;
  border: none;
  outline: none;
  font-family: inherit;
  font-size: 14px;
  color: blue;
  cursor: pointer;
  outline: none;
  display: inline-block;
  transition: all 0.3s ease-out;

  &:hover {
    text-decoration: underline;
  }
}
</style>
